<div
  class="inline-single-select"
  [ngClass]="{ 'inline-single-select--disabled': !inlineSingleSelectInput.items.length || isDisabled }"
  (click)="presentPopover($event)"
>
  <div class="inline-single-select__btn">
    <div>
      <div
        *ngIf="
          inlineSingleSelectInput.showSelectedValueAsInputLabel
            ? inlineSingleSelectInput.selectedValue?.displayName ?? inlineSingleSelectInput.inputLabel
            : inlineSingleSelectInput.inputLabel as inputLabel
        "
      >
        {{ inputLabel.toString() | translate }}
      </div>
    </div>
    <div class="inline-single-select__drop-down-chevron-container">
      <img class="inline-single-select__drop-down-chevron" src="assets/common/chevron-close-block.svg" />
    </div>
  </div>
</div>
